<template>
  <div :id="'drop-area-div-' + id" class="relative z-50">
    <input
      v-for="(attachment, index) in attachments"
      :key="index"
      type="hidden"
      name="attachments[]"
      :data-id="attachment.uid"
      :value="attachment.uid"
    />
    <spinner v-if="loading > 0" css="float: left"></spinner>
    <div v-else>
      <div
        v-if="!preventAdd && (!avatar || (avatar && attachments.length === 0))"
        class="border-2 border-dashed border-red-light rounded-2xl bg-white py-16"
        @click.stop.prevent="chooseFile"
      >
        <div v-if="attachments" class="d-flex align-items-center flex-column">
          <svg
            width="49"
            height="44"
            viewBox="0 0 49 44"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            class="mb-6"
          >
            <path
              d="M2 42H0.5C0.5 42.8284 1.17157 43.5 2 43.5L2 42ZM47.5 42V43.5C48.3284 43.5 49 42.8284 49 42H47.5ZM26.0607 0.93934C25.4749 0.353553 24.5251 0.353553 23.9393 0.93934L14.3934 10.4853C13.8076 11.0711 13.8076 12.0208 14.3934 12.6066C14.9792 13.1924 15.9289 13.1924 16.5147 12.6066L25 4.12132L33.4853 12.6066C34.0711 13.1924 35.0208 13.1924 35.6066 12.6066C36.1924 12.0208 36.1924 11.0711 35.6066 10.4853L26.0607 0.93934ZM0.5 34V42H3.5V34H0.5ZM2 43.5H47.5V40.5H2V43.5ZM49 42V34H46V42H49ZM26.5 34V2H23.5V34H26.5Z"
              fill="#EA5160"
            />
          </svg>
          <span class="font-bold text-violet"
            >Dodaj plik lub przenieś pliki tutaj</span
          >
        </div>
        <div
          v-if="attachments && attachments.length === 0"
          class="flex justify-center"
        >
          <span class="text-violet text-center pt-1"
            >Brak załączonych plików</span
          >
        </div>
        <div v-else class="flex justify-center">
          <span class="text-violet text-center pt-1"
            >Przeciągnij/Dodaj kolejne pliki</span
          >
        </div>
      </div>
      <div
        v-if="attachments && attachments.length > 0"
        class="flex flex-wrap w-full my-6 gap-5"
      >
        <div
          v-for="(attachment, index) in attachments"
          :key="index"
          class="w-[23.8%] relative"
          @click="downloadFile(attachment.uid)"
        >
          <div class="bg-cyan-light rounded-lg flex items-center p-5">
            <svg
              width="27"
              height="32"
              viewBox="0 0 27 32"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M1 31.5V1H21.5L26.5 6V31.5H1Z" stroke="#591144" />
              <path d="M6.5 9H20.5" stroke="#591144" />
              <path d="M6.5 14H20.5" stroke="#591144" />
              <path d="M6.5 19H20.5" stroke="#591144" />
              <path d="M6.5 24H14" stroke="#591144" />
            </svg>
            <span class="ml-5 text-violet break-all">
              {{ attachment.name | truncate80 }}</span
            >
          </div>
          <span
            class="absolute top-[12px] right-[11px] pointerable"
            @click.stop.prevent="remove(attachment.uid)"
          >
            <svg
              width="13"
              height="13"
              viewBox="0 0 13 13"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M1 1L12 12" stroke="#591144" stroke-linejoin="round" />
              <path d="M1 12L12 1" stroke="#591144" stroke-linejoin="round" />
            </svg>
          </span>
        </div>
        <!--            <div class="d-flex justify-content-center flex-column align-items-center w-100">-->
        <!--              <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" fill="#6dc0ac" height="44px" width="44px" version="1.1" x="0px"-->
        <!--                   y="0px" viewBox="0 0 486.3 486.3" style="enable-background:new 0 0 486.3 486.3;" xml:space="preserve">-->
        <!--                      <path-->
        <!--                        d="M395.5,135.8c-5.2-30.9-20.5-59.1-43.9-80.5c-26-23.8-59.8-36.9-95-36.9c-27.2,0-53.7,7.8-76.4,22.5    c-18.9,12.2-34.6,28.7-45.7,48.1c-4.8-0.9-9.8-1.4-14.8-1.4c-42.5,0-77.1,34.6-77.1,77.1c0,5.5,0.6,10.8,1.6,16    C16.7,200.7,0,232.9,0,267.2c0,27.7,10.3,54.6,29.1,75.9c19.3,21.8,44.8,34.7,72,36.2c0.3,0,0.5,0,0.8,0h86    c7.5,0,13.5-6,13.5-13.5s-6-13.5-13.5-13.5h-85.6C61.4,349.8,27,310.9,27,267.1c0-28.3,15.2-54.7,39.7-69    c5.7-3.3,8.1-10.2,5.9-16.4c-2-5.4-3-11.1-3-17.2c0-27.6,22.5-50.1,50.1-50.1c5.9,0,11.7,1,17.1,3c6.6,2.4,13.9-0.6,16.9-6.9    c18.7-39.7,59.1-65.3,103-65.3c59,0,107.7,44.2,113.3,102.8c0.6,6.1,5.2,11,11.2,12c44.5,7.6,78.1,48.7,78.1,95.6    c0,49.7-39.1,92.9-87.3,96.6h-73.7c-7.5,0-13.5,6-13.5,13.5s6,13.5,13.5,13.5h74.2c0.3,0,0.6,0,1,0c30.5-2.2,59-16.2,80.2-39.6    c21.1-23.2,32.6-53,32.6-84C486.2,199.5,447.9,149.6,395.5,135.8z"/>-->
        <!--                <path-->
        <!--                  d="M324.2,280c5.3-5.3,5.3-13.8,0-19.1l-71.5-71.5c-2.5-2.5-6-4-9.5-4s-7,1.4-9.5,4l-71.5,71.5c-5.3,5.3-5.3,13.8,0,19.1    c2.6,2.6,6.1,4,9.5,4s6.9-1.3,9.5-4l48.5-48.5v222.9c0,7.5,6,13.5,13.5,13.5s13.5-6,13.5-13.5V231.5l48.5,48.5    C310.4,285.3,318.9,285.3,324.2,280z"/>-->
        <!--                    </svg>-->
        <!--              <p class="mb-0">Przeciągnij/Dodaj kolejne pliki</p>-->
        <!--            </div>-->
      </div>
      <div v-if="limit" class="mt-4">
        <span v-if="atts_size > limit" class="text-red-light">
          <strong>UWAGA!</strong> Przekroczono limit rozmiaru załączników!
        </span>
        Limit rozmiaru plików: <strong>{{ limit }} MB</strong>
      </div>
    </div>
    <input
      :id="'file-' + id"
      type="file"
      name="files[]"
      multiple="multiple"
      class="hidden"
      :class="{ 'files-required': required }"
    />
    <hr v-if="attachments && attachments.length > 0" class="my-8 bg-violet" />
  </div>
</template>
<style></style>
<script>
// import auth from '../../../services/auth'
import $ from "jquery";
import api from "../../../services/api";
import "dm-file-uploader";
import spinner from "@/components/partials/misc/spinner";

export default {
  props: [
    "upload_url",
    "url",
    "atts",
    "required",
    "dates",
    "size",
    "prevent_edit",
    "stream",
    "avatar",
    "hideInfo",
    "limit",
    "preventAdd",
    "tag",
    "base",
    "code",
  ],
  data() {
    return {
      loading: 0,
      id: Math.random().toString(36).substring(7),
      attachments: this.attsChanged(),
    };
  },
  watch: {
    atts: function () {
      this.attsChanged();
    },
  },
  computed: {
    atts_size: function () {
      let size = 0;
      for (let i = 0; i < this.attachments.length; i++) {
        size += this.attachments[i].size;
      }
      return (size / 1024 / 1024).toFixed(2);
    },
    is_editable: function () {
      if (this.prevent_edit) {
        return 0;
      }
      return 1;
    },
    file_tag: function () {
      if (this.tag) {
        return [this.tag];
      }
      return [];
    },
  },
  mounted() {
    let self = this;
    $("#drop-area-div-" + this.id).dmUploader({
      url: window.CONFIG.api_url + "/" + self.upload_url,
      method: "POST",
      extraData: {
        is_editable: self.is_editable,
        tags: self.file_tag,
      },
      onNewFile: function (id, file) {
        self.loading++;
        self.$emit("uploadStarted", self.loading);
        $("#drop-area-div-" + this.id + " > .attachments").append(
          '<div class="col-md-12 list-group-item" style="text-align: left;"><div  style="text-align: left; margin-left: 0px !important"><i class="fa fa-file-o text-xs" style="margin-right: 10px"></i>' +
            file.name +
            '<div class="progress"> <div class="progress-bar primary" id="progress-' +
            id +
            ' "></div></div></div></div>'
        );
      },
      onUploadProgress: function (id, percent) {
        $("#progress-" + id).html(percent + ("" % ""));
        $("#progress-" + id).css("width", percent + "%");
      },
      onUploadSuccess: function (id, data) {
        self.loading--;
        self.attachments.push(data);
        $("#progress-" + id)
          .closest(".list-group-item")
          .remove();
        self.$emit("uploadSuccess", data);
      },
      onUploadError: function (id) {
        self.loading--;
        $("#progress-" + id).html(
          '<span style="font-weight: bold">Błąd przesyłania pliku. Rozmiar plików nie może przekraczać w sumie 35MB.</span>'
        );
        $("#progress-" + id).attr(
          "style",
          "background-color: red !important; width: 100%"
        );
      },
    });
  },
  events: {
    clearAttachments: function () {
      this.attachments = [];
    },
  },
  components: {
    spinner,
  },
  methods: {
    downloadFile(uid) {
      api.get(
        "/client/" + this.base + "/files/" + uid,
        { code: this.code },
        function (data) {
          window.location.href = data.url;
        }
      );
    },
    clear() {
      this.attachments = [];
    },
    remove: function (uid) {
      for (var i = 0; i < this.attachments.length; i++) {
        if (this.attachments[i].uid === uid) {
          $.ajax({
            url: window.CONFIG.api_url + "/client/files/" + uid,
            method: "DELETE",
          }).done(function () {
            $(this).addClass("done");
          });
          this.attachments.splice(i, 1);
        }
      }
    },
    attsChanged() {
      if (Array.isArray(this.atts)) {
        this.attachments = this.atts;
      } else {
        this.attachments = [];
        for (let prop in this.atts) {
          if (Object.prototype.hasOwnProperty.call(this.atts, prop)) {
            if (!isNaN(parseInt(prop))) {
              this.attachments.push(this.atts[prop]);
            }
          }
        }
      }
      return this.attachments;
    },
    chooseFile: function () {
      $("#file-" + this.id).trigger("click");
    },
  },
};
</script>
